export const validationTranslationKeys = {
  authFormErrorPasswordIsToShort: 'auth-form.error-password-is-to-short',
  authFormErrorSpacings: 'auth-form.error-spacings',
}
